import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es6.regexp.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as d3 from 'd3';
import { fixedDecimals, leftPadNumber, isInternetExplorer11 } from '../../../utils/vuex';
import drawTextMixin from './d3textMixin.js';
var SVG_WIDTH = 40;
var SVG_HEIGHT = 60;
var SVG_RECT_SIZE = 200;
var SVG_RECT_MARGIN = 4;
var SVG_PATHS = {
  // MINUS
  '-': 'M29.742 34.594 29.742 31 10 31 10 34.594',
  // COMMA
  ',': 'M20.7015399,40 C18.4615392,40 16.7630772,41.7723082 16.7630772,43.9384627 C16.7630772,45.2676939 17.378462,46.4984635 18.3630776,47.2123099 L16,56.9353898 L19.7415396,56.9353898 L23.7292331,47.8030793 C24.4430795,46.2523096 24.6892334,45.1200016 24.6892334,43.9384627 C24.6892334,41.7723082 22.9907714,40 20.7015399,40 L20.7015399,40 Z',
  // DOT
  '.': 'M16,44.3076936 C16,46.7446174 17.8707698,48.664618 20.3076936,48.664618 C22.7938482,48.664618 24.664618,46.7446174 24.664618,44.3076936 C24.664618,41.9200006 22.7938482,40 20.3076936,40 C17.8707698,40 16,41.9200006 16,44.3076936 L16,44.3076936 Z',
  // ZERO
  0: 'M20.1015418,13 C12.8153858,13 9,19.2523096 9,30.4769284 C9,41.750778 12.8153858,48.0030876 20.1015418,48.0030876 C27.3876979,48.0030876 31.2030837,41.750778 31.2030837,30.4769284 C31.2030837,19.2523096 27.3876979,13 20.1015418,13 Z M20.1015418,44.6553942 C18.1815412,44.6553942 16.7292331,43.9907786 15.6461559,42.4892397 L25.9600051,21.5661564 C26.57539,23.7569263 26.8461593,26.686158 26.8461593,30.4769284 C26.8461593,40.5200084 24.3107739,44.6553942 20.1015418,44.6553942 Z M20.1015418,16.3230779 C22.0461578,16.3230779 23.5476967,16.9876935 24.6061586,18.5138478 L14.2430785,39.3384695 C13.6523091,37.1476996 13.3815398,34.2430834 13.3815398,30.4769284 C13.3815398,20.4338484 15.9415406,16.3230779 20.1015418,16.3230779 Z',
  // ONE
  1: 'M23.7107734 44.5230862 23.7107734 14 20.0923108 14 10 20.2523096 11.7969236 23.2061566 19.5753875 18.4800014 19.5753875 44.5230862 11.2307696 44.5230862 11.2307696 47.8953949 30.8000063 47.8953949 30.8000063 44.5230862 z',
  // TWO
  2: 'M19.3630801,13 C14.7846171,13 11.6830777,14.5753851 9,17.8492322 L11.8553855,20.0646175 C13.9969246,17.5292321 15.8184636,16.4461549 19.1661569,16.4461549 C22.9569273,16.4461549 25.2215434,18.7846171 25.2215434,22.6000029 C25.2215434,28.1138507 22.4646195,31.8061596 9.68923098,44.0646248 L9.68923098,47.4369335 L29.8492371,47.4369335 L30.3661603,43.9169325 L14.3907709,43.9169325 C25.5661589,33.7261601 29.5784678,28.6800048 29.5784678,22.4523106 C29.5784678,17.0615397 25.763082,13 19.3630801,13 L19.3630801,13 Z',
  // THREE
  3: 'M19.6830802,13 C16.2369253,13 12.9384627,14.1815388 10.0584619,16.889232 L12.3476933,19.4246173 C14.587694,17.332309 16.5815408,16.2984625 19.5353878,16.2984625 C23.0800043,16.2984625 25.9353898,18.3169247 25.9353898,22.0584643 C25.9353898,26.0953886 22.7600042,27.9661584 19.486157,27.9661584 L17.4923103,27.9661584 L16.975387,31.2400055 L19.8307725,31.2400055 C23.8430814,31.2400055 26.8461593,32.8153906 26.8461593,37.6646229 C26.8461593,41.9230857 24.0400046,44.5815481 19.3138493,44.5815481 C16.53231,44.5815481 13.7015399,43.4738554 11.7815393,41.2092393 L9,43.4738554 C11.5846162,46.6246256 15.6215405,48.0030876 19.4123109,48.0030876 C26.4276976,48.0030876 31.1784683,43.5477016 31.1784683,37.6646229 C31.1784683,32.4461598 27.4369287,29.6892358 23.4738505,29.3692357 C27.0676978,28.7046202 30.095391,25.5784654 30.095391,21.4676949 C30.095391,16.8646166 26.0830821,13 19.6830802,13 L19.6830802,13 Z',
  // FOUR
  4: 'M31.473853 35.8923146 27.0923132 35.8923146 27.0923132 26.2676963 23.6461583 26.2676963 23.1292351 35.8923146 13.3815398 35.8923146 22.3907733 14.4523081 18.9446184 13 9 36.1876993 9 39.1907772 23.0800043 39.1907772 23.1046197 47.4369335 27.0923132 47.4369335 27.0923132 39.1907772 31.473853 39.1907772 z',
  // FIVE
  5: 'M29.1846215,14 L11.2400007,14 L11.2400007,30.9353898 L14.5630786,30.9353898 C16.53231,30.196928 17.8369258,29.8030817 19.8553879,29.8030817 C23.252312,29.8030817 25.9600051,31.57539 25.9600051,37.040007 C25.9600051,42.3077009 23.3261582,45.0400094 18.8707722,45.0400094 C15.9415406,45.0400094 13.6030783,44.0307783 11.5600008,41.9138546 L9,44.3753938 C11.633847,46.9353946 14.7353864,48.4615489 18.8215414,48.4615489 C25.8123128,48.4615489 30.2923142,43.9323168 30.2923142,37.163084 C30.2923142,30.3938511 26.57539,26.5292346 21.0369267,26.5292346 C18.9938492,26.5292346 17.2461563,26.8738501 15.1784634,27.9815427 L15.1784634,17.2984625 L28.5692367,17.2984625 L29.1846215,14 Z',
  // SIX
  6: 'M21.307696,25.3569268 C17.9846181,25.3569268 15.3015404,26.7107734 13.1353859,29.9353898 C13.332309,21.664618 16.3107715,16.3476933 21.5292346,16.3476933 C23.375389,16.3476933 25.1476972,16.8400012 26.6738515,17.7753861 L28.2984674,14.9692314 C26.3784668,13.689231 24.2123123,13 21.6030807,13 C13.6769245,13 9,20.1876945 9,31.4123133 C9,41.504624 12.0030778,48.0030876 20.2492342,48.0030876 C26.1323129,48.0030876 30.907699,43.5230862 30.907699,36.040007 C30.907699,28.8030817 26.5261592,25.3569268 21.307696,25.3569268 Z M20.2246188,44.6553942 C15.4000019,44.6553942 13.3569244,41.2092393 13.1846167,33.5538524 C14.8830787,30.6984669 17.4184641,28.7538509 20.6676959,28.7538509 C24.2615431,28.7538509 26.6738515,30.57539 26.6738515,36.1384686 C26.6738515,41.4061625 24.507697,44.6553942 20.2246188,44.6553942 Z',
  // SEVEN
  7: 'M16.5476943 48.3630874 30.0615446 17.1753856 30.0615446 14 10 14 10 17.4461549 25.9015433 17.4461549 12.6830777 47.1815485 z',
  // EIGHT
  8: 'M29.7107758,21.6153872 C29.7107758,15.6092316 24.4676973,13 19.5446189,13 C15.0892329,13 9.37846196,15.633847 9.37846196,21.8369258 C9.37846196,25.6276961 11.200001,27.8676968 14.7938482,29.5907743 C10.6830777,31.4861595 8,34.2676988 8,38.4277 C8,43.8184709 12.1846167,48.0030876 19.4461573,48.0030876 C26.6092364,48.0030876 31.0892378,43.8923171 31.0892378,38.3538539 C31.0892378,34.1692372 28.2338523,31.0676978 23.8276971,29.2461588 C27.5938521,27.1784658 29.7107758,24.9138498 29.7107758,21.6153872 Z M26.7323134,38.4030846 C26.7323134,41.9723165 24.1476972,44.6553942 19.4215419,44.6553942 C14.7446174,44.6553942 12.3569244,42.2923166 12.3569244,38.4523154 C12.3569244,34.1692372 14.843079,32.0523135 17.6492337,30.7723131 C22.9907738,32.6184675 26.7323134,33.8492371 26.7323134,38.4030846 Z M13.464617,21.8861565 C13.464617,18.2923093 15.7046177,16.200001 19.5446189,16.200001 C23.4092354,16.200001 25.6246207,18.3661555 25.6246207,21.7630796 C25.6246207,24.864619 24.0492356,26.4400041 20.8984655,28.2123123 C16.2953871,26.7353888 13.464617,25.8000039 13.464617,21.8861565 Z',
  // NINE
  9: 'M19.9784649,13 C13.8738476,13 9,16.8646166 9,24.1261572 C9,30.9200054 13.0615397,34.9569297 18.6984645,34.9569297 C22.120004,34.9569297 24.6800048,33.3076985 26.6246207,30.9200054 C26.1569283,38.9692387 21.3815422,42.6615475 12.0030778,45.270779 L12.9630781,48.4215492 C25.6400051,44.9261635 31.0307759,40.5692391 31.0307759,26.8584657 C31.0307759,18.3415401 27.3630825,13 19.9784649,13 Z M19.4615416,31.6584672 C15.5969251,31.6584672 13.2830782,29.4430819 13.2830782,24.2738496 C13.2830782,19.0800018 15.5723097,16.3476933 19.9784649,16.3476933 C24.4830816,16.3476933 26.6246207,19.276925 26.7230823,27.252312 C24.7046202,29.9846205 22.5138503,31.6584672 19.4615416,31.6584672 Z'
};
export default {
  name: 'CoreChartOdometer',
  mixins: [drawTextMixin],
  props: {
    size: {
      type: Number,
      "default": 0
    },
    minLength: {
      type: Number,
      "default": 8
    },
    fixTo: {
      type: Number,
      "default": 2
    },
    value: {
      type: [Number, String],
      "default": 0
    }
  },
  computed: {
    color: function color() {
      return this.$store.state.app.UiTheme ? '#eee' : '#333';
    },
    textColor: function textColor() {
      return !this.$store.state.app.UiTheme ? '#eee' : '#333';
    }
  },
  watch: {
    size: function size() {
      this.draw();
    },
    value: function value() {
      this.draw();
    },
    minLength: function minLength() {
      this.draw();
    },
    fixTo: function fixTo() {
      this.draw();
    },
    color: function color() {
      this.draw();
    },
    textColor: function textColor() {
      this.draw();
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.draw();
    });
  },
  methods: {
    leftPadZeroes: function leftPadZeroes(num) {
      var minLengthParam = this.minLength || 8;
      var minLength = Math.max(minLengthParam, SVG_RECT_SIZE / SVG_WIDTH);
      return leftPadNumber(num, minLength, 0);
    },
    draw: function draw() {
      var _this2 = this;
      var valueNumber = parseFloat(this.value);

      // clear existing svg content
      d3.select(this.$el).selectAll('*').remove();

      // render "N/A" if value is not a number
      if (isNaN(parseFloat(this.value))) {
        return this.drawNotAvailable();
      }
      var valueString = this.leftPadZeroes(fixedDecimals(valueNumber, this.fixTo));
      var svg = d3.select(this.$el).attr('width', this.size || '100%').attr('height', this.size || '100%').attr('viewBox', "".concat(-SVG_RECT_MARGIN, " 0 ").concat(SVG_RECT_SIZE + SVG_RECT_MARGIN * 2, " ").concat(SVG_HEIGHT)).attr('transform', 'translate(0, 0)').append('g').attr('class', 'container');
      var scaleFactor = Math.min(1, SVG_RECT_SIZE / valueString.length / SVG_WIDTH);
      valueString.split('').forEach(function (_char, idx) {
        var group = svg.append('g').attr('transform', "translate(".concat(idx * SVG_WIDTH, ", 0)"));
        group.append('rect').attr('x', 1).attr('y', 1).attr('width', SVG_WIDTH - 2).attr('height', SVG_HEIGHT - 2).attr('rx', 6).attr('fill', _this2.color);
        group.append('path').attr('x', idx * SVG_WIDTH + 1).attr('d', SVG_PATHS[_char] || '').attr('fill', _this2.textColor);
      });
      var container = d3.select(this.$el).select('.container');
      if (isInternetExplorer11()) {
        container.attr('transform', "scale(".concat(scaleFactor, ", ").concat(scaleFactor, ") translate(0, ").concat((SVG_HEIGHT - 2) / 2, ")"));
      } else {
        container.attr('transform-origin', '0 50%').attr('transform', "scale(".concat(scaleFactor, ", ").concat(scaleFactor, ")"));
      }
    }
  }
};